export const galleryImages = [
    {
      id: 1,
      src: "/img/project_gallery/driveway_project_1_after.jpg",
      alt: "Driveway Project 1",
      category: "driveway"
    },
    {
      id: 2,
      src: "/img/project_gallery/driveway_project_2_after.jpg",
      alt: "Driveway Project 2",
      category: "driveway"
    },
    {
      id: 3,
      src: "/img/project_gallery/driveway_project_3_after.jpg",
      alt: "Driveway Project 3",
      category: "driveway"
    },
    {
      id: 4,
      src: "/img/project_gallery/driveway_project_4_after.jpg",
      alt: "Driveway Project 4",
      category: "driveway"
    },
    {
      id: 5,
      src: "/img/project_gallery/patio_project_1_after.jpg",
      alt: "Patio Project 1",
      category: "patio"
    },
    {
      id: 6,
      src: "/img/project_gallery/patio_project_2_after.jpg",
      alt: "Patio Project 2",
      category: "patio"
    },
    {
      id: 7,
      src: "/img/project_gallery/patio_project_3_after.jpg",
      alt: "Patio Project 3",
      category: "patio"
    },
    {
      id: 8,
      src: "/img/project_gallery/patio_project_4_after.jpg",
      alt: "Patio Project 4",
      category: "patio"
    },
    {
      id: 9,
      src: "/img/project_gallery/sidewalk_project_1_after.jpg",
      alt: "Sidewalk Project 1",
      category: "sidewalk"
    },
    {
      id: 10,
      src: "/img/project_gallery/sidewalk_project_2_after.jpg",
      alt: "Sidewalk Project 2",
      category: "sidewalk"
    },
    {
      id: 11,
      src: "/img/project_gallery/sidewalk_project_3_after.jpg",
      alt: "Sidewalk Project 3",
      category: "sidewalk"
    },
    {
      id: 12,
      src: "/img/project_gallery/sidewalk_project_4_after.jpg",
      alt: "Sidewalk Project 4",
      category: "sidewalk"
    },
    {
      id: 13,
      src: "/img/project_gallery/sidewalk_project_5_after.jpg",
      alt: "Sidewalk Project 5",
      category: "sidewalk"
    },
    {
      id: 14,
      src: "/img/project_gallery/sidewalk_project_6_after.jpg",
      alt: "Sidewalk Project 6",
      category: "sidewalk"
    },
    {
      id: 15,
      src: "/img/project_gallery/sidewalk_project_7_after.jpg",
      alt: "Sidewalk Project 7",
      category: "sidewalk"
    },
    {
      id: 16,
      src: "/img/project_gallery/sidewalk_project_8_after.jpg",
      alt: "Sidewalk Project 8",
      category: "sidewalk"
    },
    {
      id: 17,
      src: "/img/project_gallery/slabs_project_1_after.jpg",
      alt: "Slabs Project 1",
      category: "slabs"
    },
    {
      id: 18,
      src: "/img/project_gallery/slabs_project_2_after.jpg",
      alt: "Slabs Project 2",
      category: "slabs"
    },
    {
      id: 19,
      src: "/img/project_gallery/slabs_project_3_after.jpg",
      alt: "Slabs Project 3",
      category: "slabs"
    },
    {
      id: 20,
      src: "/img/project_gallery/slabs_project_4_after.jpg",
      alt: "Slabs Project 4",
      category: "slabs"
    },
    {
      id: 21,
      src: "/img/project_gallery/custom_project_1_after.jpg",
      alt: "Custom Project 1",
      category: "custom"
    }
  ]